export const intercept_str = (
  str: string,
  startIndex: number,
  endIndex: number,
) => {
  if (str) {
    const start_str = str.slice(0, startIndex)
    const end_str = str.slice(-endIndex)
    return `${start_str}...${end_str}`
  }
}
export const copy_text = (str: string) => {
  const input = document.createElement('input')
  document.body.appendChild(input)
  input.setAttribute('value', str)
  input.select()
  if (document.execCommand('copy')) {
    document.execCommand('copy')
    // window.alert('Successful replication')
  }
  document.body.removeChild(input)
}
